import { render, staticRenderFns } from "./DispatchWork.vue?vue&type=template&id=1c5f1250&scoped=true"
import script from "./DispatchWork.vue?vue&type=script&lang=js"
export * from "./DispatchWork.vue?vue&type=script&lang=js"
import style0 from "./DispatchWork.vue?vue&type=style&index=0&id=1c5f1250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f1250",
  null
  
)

export default component.exports